export default __webpack_public_path__ + "static/media/footer2.0f93d17d.jpg";